module.exports = __webpack_public_path__ + "static/media/accessiblity.06c6df2a.svg";